import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn — merge condicional de classes Tailwind (padrão shadcn/ui).
 * Resolve conflitos de utilitários (ex.: "p-2" + "p-4" → "p-4").
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
